function subpage() {
	const mainSubpage = document.querySelector('main.subpage');
	if (!mainSubpage) return;

	ScrollTrigger.create({
		trigger: ".highlighted-text-content",
		start: "bottom bottom",
		end: "top top",
		onUpdate: function (self) {
			const scrollPercent = self.progress * 100;
			const elements = document.querySelectorAll('.highlighted-text-content span');
			const totalElements = elements.length;

			const index = Math.min(totalElements - 1, Math.floor(scrollPercent / (100 / totalElements)));

			if (self.direction === 1) {
				for (let i = 0; i <= index; i++) {
					elements[i].classList.add('highlight');
				}
			} else if (self.direction === -1) {
				for (let i = index + 1; i < totalElements; i++) {
					elements[i].classList.remove('highlight');
				}
			}
		}
	});

	activateShuffleOnVisible(".fh-shuffle", ".subpage .big-numbers");

	if (window.matchMedia("(min-width: 768px)").matches) {
		ScrollTrigger.create({
			trigger: ".bulletpoints-photo",
			pin: ".bulletpoints-photo img",
			start: "top 146px",
			end: "bottom " + ($('.bulletpoints-photo img').height() + 146) + "px",
		});
	}

	if (window.matchMedia("(min-width: 768px)").matches) {
		ScrollTrigger.create({
			trigger: ".tiles-icon-image.fixed-image",
			pin: ".tiles-icon-image.fixed-image img",
			start: "top 146px",
			end: "bottom " + ($('.tiles-icon-image.fixed-image img').height() + 146) + "px",
		});
	}

	const tilesSwiper = document.querySelectorAll('.swiper-tiles');
	tilesSwiper.forEach(function (slider) {
		new Swiper(slider, {
			loop: false,
			spaceBetween: 32,
			slidesPerView: 1,
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
			breakpoints: {
				992: {
					slidesPerView: 3,
				},
				576: {
					slidesPerView: 2,
				},
			}
		})
	});

	const opinionsSwiper = document.querySelectorAll('.swiper-opinions');
	opinionsSwiper.forEach(function (slider) {
		new Swiper(slider, {
			loop: false,
			spaceBetween: 32,
			slidesPerView: 1,
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
		})
	});

	$('.video').on('click', function() {
		var videoId = $(this).data('vid');
		var youtubeSrc = 'https://www.youtube.com/embed/' + videoId + '?autoplay=1';

		$('#videoModal iframe').attr('src', youtubeSrc);
	});

	$('#videoModal').on('hidden.bs.modal', function () {
		$('#videoModal iframe').attr('src', '');
	});

	$('.videos select').on('change', function() {
		const year = $(this).val();
		$('.videos-list .video').addClass('video-hide');
		$('.videos-list .video[data-year="' + year + '"]').removeClass('video-hide');
	});


	$('.gathering-toggle').on('click', function() {
		$(this).toggleClass('open');
		$(this).siblings('.gathering-content').slideToggle();
	});
}
